<template>
	<card layout="grid" tag="section">
		<template #default>
			<loading v-if="loading"></loading>
			<div v-else class="widget-container" :class="{ 'widget-container-vertical': vertical }">
				<div class="rollover" v-for="(g, i) in offices" :key="i">
					<router-link
						class="default-link"
						:to="{ name: '_locationDetail', params: { Id: g.locationId } }"></router-link>
					<div>
						<user-picture
							:user="{ FirstName: g.location }"
							size="large"
							field="TileImage"
							:uuid="g.uuid"></user-picture>

						<div class="is-flex is-flex-direction-column mt-2">
							<div>
								<h3>{{ g.location }}</h3>
							</div>
							<div class="mt-1">
								<div>
									<span class="has-text-grey">Total billings:&nbsp;</span>
									<strong>{{ currencyFormat.format(g.totalBillingsUsd) }}</strong>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- <o-button outlined>View full list</o-button> -->
		</template>
	</card>
</template>
<script>
	import { ref, inject, computed, onMounted } from "vue";
	import { currencyFormat } from "@/services/utils";
	export default {
		props: {
			filters: {
				type: Object,
				default: () => {
					return {};
				}
			},
			take: {
				type: Number,
				default: 3
			},
			vertical: {
				type: Boolean,
				default: false
			}
		},
		setup(props, context) {
			const $http = inject("$http");
			const $error = inject("$error");

			const offices = ref([]);

			const loading = ref(true);

			const GetData = async () => {
				try {
					loading.value = true;
					const response = await $http.post("/api/v2/widget/topOffices?take="+props.take, {
						filter: props.filters
					});
					offices.value = response.data;
					loading.value = false;
				} catch (err) {
					$error("Could not retrieve offices.");
					loading.value = false;
				}
			};

			onMounted(() => {
				GetData();
			});

			return {
				currencyFormat,
				offices,
				loading
			};
		}
	};
</script>
<style lang="scss" scoped>
	@import "@/assets/css/globalVars.scss";

	.widget-container.widget-container-vertical {
		flex-direction: row;
		flex-wrap: wrap;

		& > .rollover > div {
			flex-direction: column;
			gap: 0;

			& > div:nth-child(2) {
				padding-left: $radius-small;
				padding-right: $radius-small;
			}
		}
	}

</style>